import { useEffect, useState } from "react";
import DocumentGeneratorModal from "./documentGeneratorModal";
import ButtonNew from "components/buttonNew/buttonNew";
import { FileText } from "@phosphor-icons/react";
import { Document } from "assets/icons";


export interface DocumentGeneratorComponentProps {
  incomingAcquisitionId?: string | number;
  incomingBuilding?: any;
  incomingUnit?: any;
  incomingContract?: any;
  incomingDocumentCategory?: string;
  pictureSelection?: boolean;
  size?: "sm" | "md" | "lg";
}


const DocumentGeneratorComponent = ({
  incomingAcquisitionId,
  incomingBuilding,
  incomingUnit,
  incomingContract,
  incomingDocumentCategory,
  size = "lg",
}: DocumentGeneratorComponentProps) => {
  const [isDocumentGeneratorModalOpen, setIsDocumentGeneratorModalOpen] = useState(false);
  const [acquisitionId, setAcquisitionId] = useState<string | number | null>(null);
  const [building, setBuilding] = useState<any>(null);
  const [unit, setUnit] = useState<any>(null);
  const [contract, setContract] = useState<any>(null);
  const [documentCategory, setDocumentCategory] = useState<string | null>(null);

  useEffect(() => {
    console.log("incomingAcquisitionId", incomingAcquisitionId);
    setAcquisitionId(incomingAcquisitionId as string | number | null);
  }, [incomingAcquisitionId]);

  useEffect(() => {
    console.log("incomingBuilding", incomingBuilding);
    setBuilding(incomingBuilding);
  }, [incomingBuilding]);

  useEffect(() => {
    console.log("incomingUnit", incomingUnit);
    setUnit(incomingUnit);
  }, [incomingUnit]);

  useEffect(() => {
    console.log("incomingContract", incomingContract);
    setContract(incomingContract);
  }, [incomingContract]);

  useEffect(() => {
    setDocumentCategory(incomingDocumentCategory as string | null);
  }, [incomingDocumentCategory]);

  const handleDocumentGeneratorModalClose = () => {
    setIsDocumentGeneratorModalOpen(false);
  };

  return (
    <div className="flex flex-col gap-8">
      <>
        {size == "lg" ? <ButtonNew
          icon={<FileText weight="duotone" />}
          onClick={() => setIsDocumentGeneratorModalOpen(true)}
          label={`${size == "lg" ? "Genereer document" : ""}`}
          variant="primaryMoss"
        /> : <Document className="cursor-pointer" onClick={() => setIsDocumentGeneratorModalOpen(true)} />}
        {isDocumentGeneratorModalOpen && <DocumentGeneratorModal
          isOpen={isDocumentGeneratorModalOpen}
          onClose={handleDocumentGeneratorModalClose}
          contract={contract ? contract : null}
          unit={unit ? unit : null}
          building={building ? building : null}
          acquisitionId={acquisitionId ? acquisitionId : null}
          documentCategory={documentCategory ? documentCategory : null}
        />}
      </>
    </div>
  );
};

export default DocumentGeneratorComponent;
